"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.GenericIconCPUImage = exports.GenericIconBookmarkImage = exports.GenericIconAnchorImage = exports.GenericIconAlertTriangleImage = exports.GenericIconAlertOctagonImage = exports.GenericIconAlertCircleImage = exports.GenericIcon = exports.FormIcon = exports.FooterSocials = exports.FooterItem = exports.FilledIconXCloseImage = exports.FilledIconWriteImage = exports.FilledIconUsersImage = exports.FilledIconTrendUpImage = exports.FilledIconStarImage = exports.FilledIconSearchImage = exports.FilledIconPhoneImage = exports.FilledIconPauseImage = exports.FilledIconMobileImage = exports.FilledIconMessageSendImage = exports.FilledIconMessageImage = exports.FilledIconMapPinImage = exports.FilledIconMailImage = exports.FilledIconLoadingImage = exports.FilledIconLightBulbImage = exports.FilledIconLayersImage = exports.FilledIconInfoImage = exports.FilledIconHomeImage = exports.FilledIconGlobeImage = exports.FilledIconFolderImage = exports.FilledIconFlagImage = exports.FilledIconFileImage = exports.FilledIconFileArrowImage = exports.FilledIconDollarImage = exports.FilledIconCheckImage = exports.FilledIconCheckCircleImage = exports.FilledIconCalendarImage = exports.FilledIconBookmarkImage = exports.FilledIcon = exports.EncircledIconXCloseImage = exports.EncircledIconWriteImage = exports.EncircledIconUsersImage = exports.EncircledIconTrendUpImage = exports.EncircledIconStarImage = exports.EncircledIconSearchImage = exports.EncircledIconPhoneImage = exports.EncircledIconPauseImage = exports.EncircledIconMobileImage = exports.EncircledIconMessageSendImage = exports.EncircledIconMessageImage = exports.EncircledIconMegaphoneImage = exports.EncircledIconMapPinImage = exports.EncircledIconMailImage = exports.EncircledIconLoadingImage = exports.EncircledIconLightBulbImage = exports.EncircledIconLayersImage = exports.EncircledIconInfoImage = exports.EncircledIconHomeImage = exports.EncircledIconGlobeImage = exports.EncircledIconFolderImage = exports.EncircledIconFlagImage = exports.EncircledIconFileImage = exports.EncircledIconFileArrowImage = exports.EncircledIconDollarImage = exports.EncircledIconCheckImage = exports.EncircledIconCheckCircleImage = exports.EncircledIconCalendarImage = exports.EncircledIconBookmarkImage = exports.EncircledIconBookOpen = exports.EncircledIcon = exports.DropdownNavItem = exports.ContactMethod = exports.CharlotteCrownWhiteImage = exports.CSSVariables = exports.CSSTypography = exports.ButtonSocialIcon = exports.ButtonPlayIcon = exports.ButtonIconZillowImage = exports.ButtonIconWebImage = exports.ButtonIconUpArrowImage = exports.ButtonIconRightArrowImage = exports.ButtonIconPlayImage = exports.ButtonIconLinkedinImage = exports.ButtonIconLeftArrowImage = exports.ButtonIconInstagramImage = exports.ButtonIconFacebookImage = exports.ButtonArrowIcon = exports.Button = exports.BackgroundImage = exports.ArticleProgressBar = exports.ArrowIcon = exports.AlgoliaSearchBox = exports.Address = exports.ABMGLogoNavIconOnlyDefaultImage = exports.ABMGLogoNavDefaultImage = exports.ABMGLogoFooterIconOnlyWhiteImage = exports.ABMGLogoFooterArcticBlueImage = exports.ABMGGroupImage = exports.ABMGBuildingWithWhiteLogoImage = exports.ABMGBuildingWithDefaultLogoImage = void 0;
exports.Tooltip = exports.SuperNav = exports.StandaloneLink = exports.SocialIconZillowImage = exports.SocialIconTwitterImage = exports.SocialIconLinkedinImage = exports.SocialIconInstagramImage = exports.SocialIconFacebookImage = exports.SocialIcon = exports.SelectedRadioImage = exports.SelectedCheckboxImage = exports.SearchNavItems = exports.SearchNav = exports.SEO = exports.QuoteIconThistleLightImage = exports.QuoteIconThistleDarkImage = exports.QuoteIconSunsetLightImage = exports.QuoteIconSunsetDarkImage = exports.QuoteIconPalmLightImage = exports.QuoteIconPalmDarkImage = exports.QuoteIconPacificLightImage = exports.QuoteIconPacificDarkImage = exports.QuoteIconHorizonLightImage = exports.QuoteIconHorizonDarkImage = exports.QuoteIconAtlanticLightImage = exports.QuoteIconAtlanticDarkImage = exports.QuoteIcon = exports.OutlinedField = exports.NewsroomNav = exports.NavLogo = exports.NavHeadshot = exports.NationalMapImage = exports.NammbaWhiteImage = exports.NahrepWhiteImage = exports.MainNav = exports.MBHeadshot = exports.LogoValueInspireGrowthImage = exports.LogoValueHaveFunImage = exports.LogoTopWorkPlaces2022Image = exports.LogoNMN2023WhiteImage = exports.LogoNMN2023DarkWhiteTextImage = exports.LogoNMN2023DarkImage = exports.LogoNMN2022Image = exports.LogoGenuineCareImage = exports.LogoFiftyBestCompaniesImage = exports.LogoEqualOpportunityLenderWhiteImage = exports.Logo = exports.Licensing = exports.InlineLink = exports.IconUpArrowImage = exports.IconRightArrowImage = exports.IconLeftArrowImage = exports.GlobalStyles = exports.GenericIconXOctagonImage = exports.GenericIconXCloseImage = exports.GenericIconVideoImage = exports.GenericIconUsersImage = exports.GenericIconUserImage = exports.GenericIconUpChevronImage = exports.GenericIconTrendUpImage = exports.GenericIconToolImage = exports.GenericIconThumbsUpImage = exports.GenericIconSlashImage = exports.GenericIconShareImage = exports.GenericIconShare2Image = exports.GenericIconSearchImage = exports.GenericIconRightChevronImage = exports.GenericIconPlusSignImage = exports.GenericIconPlayCircleImage = exports.GenericIconPhoneImage = exports.GenericIconPenToolImage = exports.GenericIconOpenBookImage = exports.GenericIconModifiedRightArrowdImage = exports.GenericIconMinimize2Image = exports.GenericIconMessageSquareImage = exports.GenericIconMessageCircleImage = exports.GenericIconMegaphoneImage = exports.GenericIconMapPinImage = exports.GenericIconMailImage = exports.GenericIconLockImage = exports.GenericIconLifeBuoyImage = exports.GenericIconLeftChevronImage = exports.GenericIconLayoutImage = exports.GenericIconInfoImage = exports.GenericIconHelpCircleImage = exports.GenericIconGlobeImage = exports.GenericIconFileTextmage = exports.GenericIconExternalLinkImage = exports.GenericIconEditImage = exports.GenericIconEdit3Image = exports.GenericIconEdit2Image = exports.GenericIconDownChevronImage = exports.GenericIconDollarSignImage = exports.GenericIconCompassImage = exports.GenericIconClockImage = exports.GenericIconChevronsRightImage = exports.GenericIconChevronsLeftImage = exports.GenericIconCheckImage = exports.GenericIconCalendarImage = exports.GenericIconCalculatorImage = void 0;
exports.useWindowSize = exports.useScroll = exports.useMobileHover = exports.useKeyboardFocus = exports.stateSelectOptions = exports.scrollToHash = exports.mediaBreakpoints = exports.getTimePeriodOfDay = exports.getRawNumber = exports.getPhoneNumbers = exports.getMonth = exports.getMediaQueries = exports.getFieldValue = exports.getDay = exports.getDate = exports.getAddress = exports.formatPhoneNumber = exports.colors = exports.VideoPlayer = exports.UnselectedRadioImage = exports.UnselectedCheckboxImage = void 0;
var _button = _interopRequireDefault(require("./components/buttons/button"));
exports.Button = _button.default;
var _arrow = _interopRequireDefault(require("./components/buttons/icons/arrow"));
exports.ButtonArrowIcon = _arrow.default;
var _social = _interopRequireDefault(require("./components/buttons/icons/social"));
exports.ButtonSocialIcon = _social.default;
var _play = _interopRequireDefault(require("./components/buttons/icons/play"));
exports.ButtonPlayIcon = _play.default;
var _item = _interopRequireDefault(require("./components/footer/item"));
exports.FooterItem = _item.default;
var _socials = _interopRequireDefault(require("./components/footer/socials"));
exports.FooterSocials = _socials.default;
var _outlinedField = _interopRequireDefault(require("./components/forms/outlined-field"));
exports.OutlinedField = _outlinedField.default;
var _arrow2 = _interopRequireDefault(require("./components/icons/arrow"));
exports.ArrowIcon = _arrow2.default;
var _encircled = _interopRequireDefault(require("./components/icons/encircled"));
exports.EncircledIcon = _encircled.default;
var _filled = _interopRequireDefault(require("./components/icons/filled"));
exports.FilledIcon = _filled.default;
var _form = _interopRequireDefault(require("./components/icons/form"));
exports.FormIcon = _form.default;
var _generic = _interopRequireDefault(require("./components/icons/generic"));
exports.GenericIcon = _generic.default;
var _social2 = _interopRequireDefault(require("./components/icons/social"));
exports.SocialIcon = _social2.default;
var _quote = _interopRequireDefault(require("./components/icons/quote"));
exports.QuoteIcon = _quote.default;
var _address = _interopRequireDefault(require("./components/general/address"));
exports.Address = _address.default;
var _videoPlayer = _interopRequireDefault(require("./components/general/video-player"));
exports.VideoPlayer = _videoPlayer.default;
var _contactMethod = _interopRequireDefault(require("./components/general/contact-method"));
exports.ContactMethod = _contactMethod.default;
var _tooltip = _interopRequireDefault(require("./components/general/tooltip"));
exports.Tooltip = _tooltip.default;
var _seo = _interopRequireDefault(require("./components/general/seo"));
exports.SEO = _seo.default;
var _background = _interopRequireDefault(require("./components/images/background"));
exports.BackgroundImage = _background.default;
var _standalone = _interopRequireDefault(require("./components/links/standalone"));
exports.StandaloneLink = _standalone.default;
var _inline = _interopRequireDefault(require("./components/links/inline"));
exports.InlineLink = _inline.default;
var _logo = _interopRequireDefault(require("./components/logos/logo"));
exports.Logo = _logo.default;
var _headshot = _interopRequireDefault(require("./components/mb/headshot"));
exports.MBHeadshot = _headshot.default;
var _licensing = _interopRequireDefault(require("./components/mb/licensing"));
exports.Licensing = _licensing.default;
var _algoliaSearchbox = _interopRequireDefault(require("./components/nav/algolia-searchbox"));
exports.AlgoliaSearchBox = _algoliaSearchbox.default;
var _articleProgressBar = _interopRequireDefault(require("./components/nav/article-progress-bar"));
exports.ArticleProgressBar = _articleProgressBar.default;
var _dropdownItem = _interopRequireDefault(require("./components/nav/dropdown-item"));
exports.DropdownNavItem = _dropdownItem.default;
var _mainNav = _interopRequireDefault(require("./components/nav/main-nav"));
exports.MainNav = _mainNav.default;
var _headshot2 = _interopRequireDefault(require("./components/nav/headshot"));
exports.NavHeadshot = _headshot2.default;
var _logo2 = _interopRequireDefault(require("./components/nav/logo"));
exports.NavLogo = _logo2.default;
var _newsroomNav = _interopRequireDefault(require("./components/nav/newsroom-nav"));
exports.NewsroomNav = _newsroomNav.default;
var _searchNav = _interopRequireDefault(require("./components/nav/search-nav"));
exports.SearchNav = _searchNav.default;
var _searchNavItems = _interopRequireDefault(require("./components/nav/search-nav-items"));
exports.SearchNavItems = _searchNavItems.default;
var _superNav = _interopRequireDefault(require("./components/nav/super-nav"));
exports.SuperNav = _superNav.default;
var _useKeyboardFocus = _interopRequireDefault(require("./hooks/use-keyboard-focus"));
exports.useKeyboardFocus = _useKeyboardFocus.default;
var _useMobileHover = _interopRequireDefault(require("./hooks/use-mobile-hover"));
exports.useMobileHover = _useMobileHover.default;
var _useScroll = _interopRequireDefault(require("./hooks/use-scroll"));
exports.useScroll = _useScroll.default;
var _useWindowSize = _interopRequireDefault(require("./hooks/use-window-size"));
exports.useWindowSize = _useWindowSize.default;
var _utils = require("./utils/utils");
exports.colors = _utils.colors;
exports.mediaBreakpoints = _utils.mediaBreakpoints;
exports.getMediaQueries = _utils.getMediaQueries;
exports.formatPhoneNumber = _utils.formatPhoneNumber;
exports.getPhoneNumbers = _utils.getPhoneNumbers;
exports.getAddress = _utils.getAddress;
exports.getDay = _utils.getDay;
exports.getMonth = _utils.getMonth;
exports.getDate = _utils.getDate;
exports.getTimePeriodOfDay = _utils.getTimePeriodOfDay;
exports.scrollToHash = _utils.scrollToHash;
exports.getFieldValue = _utils.getFieldValue;
exports.getRawNumber = _utils.getRawNumber;
exports.stateSelectOptions = _utils.stateSelectOptions;
var _globalStyles = require("./utils/global-styles");
exports.GlobalStyles = _globalStyles.GlobalStyles;
// Components

// -Buttons

// -Footer

// -Forms

// -Icons

// -General

// -Images

// -Links

// -Logos

// -MB

// -Nav

/********************************************************************/

// Hooks

/********************************************************************/

// Images

// -Buttons

// --Arrows
const ButtonIconLeftArrowImage = require("./images/buttons/icons/arrows/arrow-left-button.svg");
exports.ButtonIconLeftArrowImage = ButtonIconLeftArrowImage;
const ButtonIconRightArrowImage = require("./images/buttons/icons/arrows/arrow-right-button.svg");
exports.ButtonIconRightArrowImage = ButtonIconRightArrowImage;
const ButtonIconUpArrowImage = require("./images/buttons/icons/arrows/arrow-up-button.svg");

// --Play
exports.ButtonIconUpArrowImage = ButtonIconUpArrowImage;
const ButtonIconPlayImage = require("./images/buttons/icons/play/play-button.svg");

// --Social
exports.ButtonIconPlayImage = ButtonIconPlayImage;
const ButtonIconFacebookImage = require("./images/buttons/icons/social/facebook.svg");
exports.ButtonIconFacebookImage = ButtonIconFacebookImage;
const ButtonIconInstagramImage = require("./images/buttons/icons/social/instagram.svg");
exports.ButtonIconInstagramImage = ButtonIconInstagramImage;
const ButtonIconLinkedinImage = require("./images/buttons/icons/social/instagram.svg");
exports.ButtonIconLinkedinImage = ButtonIconLinkedinImage;
const ButtonIconWebImage = require("./images/buttons/icons/social/instagram.svg");
exports.ButtonIconWebImage = ButtonIconWebImage;
const ButtonIconZillowImage = require("./images/buttons/icons/social/instagram.svg");

// -General
exports.ButtonIconZillowImage = ButtonIconZillowImage;
const ABMGBuildingWithDefaultLogoImage = require("./images/general/abmg-building-with-logo-default.jpg");
exports.ABMGBuildingWithDefaultLogoImage = ABMGBuildingWithDefaultLogoImage;
const ABMGBuildingWithWhiteLogoImage = require("./images/general/abmg-building-with-logo-white.jpg");
exports.ABMGBuildingWithWhiteLogoImage = ABMGBuildingWithWhiteLogoImage;
const ABMGGroupImage = require("./images/general/abmg-group-photo.jpg");
exports.ABMGGroupImage = ABMGGroupImage;
const NationalMapImage = require("./images/general/national-map.svg");

// -Icons
exports.NationalMapImage = NationalMapImage;
const IconLeftArrowImage = require("./images/icons/arrows/arrow-left-regular.svg");
exports.IconLeftArrowImage = IconLeftArrowImage;
const IconRightArrowImage = require("./images/icons/arrows/arrow-right-regular.svg");
exports.IconRightArrowImage = IconRightArrowImage;
const IconUpArrowImage = require("./images/icons/arrows/arrow-up-regular.svg");

// --Encircled
exports.IconUpArrowImage = IconUpArrowImage;
const EncircledIconBookmarkImage = require("./images/icons/encircled/bookmark.svg");
exports.EncircledIconBookmarkImage = EncircledIconBookmarkImage;
const EncircledIconBookOpen = require("./images/icons/encircled/book-open.svg");
exports.EncircledIconBookOpen = EncircledIconBookOpen;
const EncircledIconCalendarImage = require("./images/icons/encircled/calendar.svg");
exports.EncircledIconCalendarImage = EncircledIconCalendarImage;
const EncircledIconCheckCircleImage = require("./images/icons/encircled/check-circle.svg");
exports.EncircledIconCheckCircleImage = EncircledIconCheckCircleImage;
const EncircledIconCheckImage = require("./images/icons/encircled/check.svg");
exports.EncircledIconCheckImage = EncircledIconCheckImage;
const EncircledIconDollarImage = require("./images/icons/encircled/dollar.svg");
exports.EncircledIconDollarImage = EncircledIconDollarImage;
const EncircledIconFileArrowImage = require("./images/icons/encircled/file-arrow.svg");
exports.EncircledIconFileArrowImage = EncircledIconFileArrowImage;
const EncircledIconFileImage = require("./images/icons/encircled/file.svg");
exports.EncircledIconFileImage = EncircledIconFileImage;
const EncircledIconFlagImage = require("./images/icons/encircled/flag.svg");
exports.EncircledIconFlagImage = EncircledIconFlagImage;
const EncircledIconFolderImage = require("./images/icons/encircled/folder.svg");
exports.EncircledIconFolderImage = EncircledIconFolderImage;
const EncircledIconGlobeImage = require("./images/icons/encircled/globe.svg");
exports.EncircledIconGlobeImage = EncircledIconGlobeImage;
const EncircledIconHomeImage = require("./images/icons/encircled/home.svg");
exports.EncircledIconHomeImage = EncircledIconHomeImage;
const EncircledIconInfoImage = require("./images/icons/encircled/info.svg");
exports.EncircledIconInfoImage = EncircledIconInfoImage;
const EncircledIconLayersImage = require("./images/icons/encircled/layers.svg");
exports.EncircledIconLayersImage = EncircledIconLayersImage;
const EncircledIconLightBulbImage = require("./images/icons/encircled/light-bulb.svg");
exports.EncircledIconLightBulbImage = EncircledIconLightBulbImage;
const EncircledIconLoadingImage = require("./images/icons/encircled/loading.svg");
exports.EncircledIconLoadingImage = EncircledIconLoadingImage;
const EncircledIconMailImage = require("./images/icons/encircled/mail.svg");
exports.EncircledIconMailImage = EncircledIconMailImage;
const EncircledIconMapPinImage = require("./images/icons/encircled/map-pin.svg");
exports.EncircledIconMapPinImage = EncircledIconMapPinImage;
const EncircledIconMegaphoneImage = require("./images/icons/encircled/megaphone.svg");
exports.EncircledIconMegaphoneImage = EncircledIconMegaphoneImage;
const EncircledIconMessageSendImage = require("./images/icons/encircled/message-send.svg");
exports.EncircledIconMessageSendImage = EncircledIconMessageSendImage;
const EncircledIconMessageImage = require("./images/icons/encircled/message.svg");
exports.EncircledIconMessageImage = EncircledIconMessageImage;
const EncircledIconMobileImage = require("./images/icons/encircled/mobile.svg");
exports.EncircledIconMobileImage = EncircledIconMobileImage;
const EncircledIconPauseImage = require("./images/icons/encircled/pause.svg");
exports.EncircledIconPauseImage = EncircledIconPauseImage;
const EncircledIconPhoneImage = require("./images/icons/encircled/phone.svg");
exports.EncircledIconPhoneImage = EncircledIconPhoneImage;
const EncircledIconSearchImage = require("./images/icons/encircled/search.svg");
exports.EncircledIconSearchImage = EncircledIconSearchImage;
const EncircledIconStarImage = require("./images/icons/encircled/star.svg");
exports.EncircledIconStarImage = EncircledIconStarImage;
const EncircledIconTrendUpImage = require("./images/icons/encircled/trend-up.svg");
exports.EncircledIconTrendUpImage = EncircledIconTrendUpImage;
const EncircledIconUsersImage = require("./images/icons/encircled/users.svg");
exports.EncircledIconUsersImage = EncircledIconUsersImage;
const EncircledIconWriteImage = require("./images/icons/encircled/write.svg");
exports.EncircledIconWriteImage = EncircledIconWriteImage;
const EncircledIconXCloseImage = require("./images/icons/encircled/x-close.svg");

// --Filled
exports.EncircledIconXCloseImage = EncircledIconXCloseImage;
const FilledIconBookmarkImage = require("./images/icons/filled/bookmark.svg");
exports.FilledIconBookmarkImage = FilledIconBookmarkImage;
const FilledIconCalendarImage = require("./images/icons/filled/calendar.svg");
exports.FilledIconCalendarImage = FilledIconCalendarImage;
const FilledIconCheckCircleImage = require("./images/icons/filled/check-circle.svg");
exports.FilledIconCheckCircleImage = FilledIconCheckCircleImage;
const FilledIconCheckImage = require("./images/icons/filled/check.svg");
exports.FilledIconCheckImage = FilledIconCheckImage;
const FilledIconDollarImage = require("./images/icons/filled/dollar.svg");
exports.FilledIconDollarImage = FilledIconDollarImage;
const FilledIconFileArrowImage = require("./images/icons/filled/file-arrow.svg");
exports.FilledIconFileArrowImage = FilledIconFileArrowImage;
const FilledIconFileImage = require("./images/icons/filled/file.svg");
exports.FilledIconFileImage = FilledIconFileImage;
const FilledIconFlagImage = require("./images/icons/filled/flag.svg");
exports.FilledIconFlagImage = FilledIconFlagImage;
const FilledIconFolderImage = require("./images/icons/filled/folder.svg");
exports.FilledIconFolderImage = FilledIconFolderImage;
const FilledIconGlobeImage = require("./images/icons/filled/globe.svg");
exports.FilledIconGlobeImage = FilledIconGlobeImage;
const FilledIconHomeImage = require("./images/icons/filled/home.svg");
exports.FilledIconHomeImage = FilledIconHomeImage;
const FilledIconInfoImage = require("./images/icons/filled/info.svg");
exports.FilledIconInfoImage = FilledIconInfoImage;
const FilledIconLayersImage = require("./images/icons/filled/layers.svg");
exports.FilledIconLayersImage = FilledIconLayersImage;
const FilledIconLightBulbImage = require("./images/icons/filled/light-bulb.svg");
exports.FilledIconLightBulbImage = FilledIconLightBulbImage;
const FilledIconLoadingImage = require("./images/icons/filled/loading.svg");
exports.FilledIconLoadingImage = FilledIconLoadingImage;
const FilledIconMailImage = require("./images/icons/filled/mail.svg");
exports.FilledIconMailImage = FilledIconMailImage;
const FilledIconMapPinImage = require("./images/icons/filled/map-pin.svg");
exports.FilledIconMapPinImage = FilledIconMapPinImage;
const FilledIconMessageSendImage = require("./images/icons/filled/message-send.svg");
exports.FilledIconMessageSendImage = FilledIconMessageSendImage;
const FilledIconMessageImage = require("./images/icons/filled/message.svg");
exports.FilledIconMessageImage = FilledIconMessageImage;
const FilledIconMobileImage = require("./images/icons/filled/mobile.svg");
exports.FilledIconMobileImage = FilledIconMobileImage;
const FilledIconPauseImage = require("./images/icons/filled/pause.svg");
exports.FilledIconPauseImage = FilledIconPauseImage;
const FilledIconPhoneImage = require("./images/icons/filled/phone.svg");
exports.FilledIconPhoneImage = FilledIconPhoneImage;
const FilledIconSearchImage = require("./images/icons/filled/search.svg");
exports.FilledIconSearchImage = FilledIconSearchImage;
const FilledIconStarImage = require("./images/icons/filled/star.svg");
exports.FilledIconStarImage = FilledIconStarImage;
const FilledIconTrendUpImage = require("./images/icons/filled/trend-up.svg");
exports.FilledIconTrendUpImage = FilledIconTrendUpImage;
const FilledIconUsersImage = require("./images/icons/filled/users.svg");
exports.FilledIconUsersImage = FilledIconUsersImage;
const FilledIconWriteImage = require("./images/icons/filled/write.svg");
exports.FilledIconWriteImage = FilledIconWriteImage;
const FilledIconXCloseImage = require("./images/icons/filled/x-close.svg");

// -Forms
exports.FilledIconXCloseImage = FilledIconXCloseImage;
const SelectedCheckboxImage = require("./images/icons/form/selected-checkbox.svg");
exports.SelectedCheckboxImage = SelectedCheckboxImage;
const SelectedRadioImage = require("./images/icons/form/selected-radio.svg");
exports.SelectedRadioImage = SelectedRadioImage;
const UnselectedRadioImage = require("./images/icons/form/unselected-radio.svg");
exports.UnselectedRadioImage = UnselectedRadioImage;
const UnselectedCheckboxImage = require("./images/icons/form/unselected-checkbox.svg");

// --Generic
exports.UnselectedCheckboxImage = UnselectedCheckboxImage;
const GenericIconAlertCircleImage = require("./images/icons/generic/alert-circle.svg");
exports.GenericIconAlertCircleImage = GenericIconAlertCircleImage;
const GenericIconAlertOctagonImage = require("./images/icons/generic/alert-octagon.svg");
exports.GenericIconAlertOctagonImage = GenericIconAlertOctagonImage;
const GenericIconAlertTriangleImage = require("./images/icons/generic/alert-triangle.svg");
exports.GenericIconAlertTriangleImage = GenericIconAlertTriangleImage;
const GenericIconAnchorImage = require("./images/icons/generic/anchor.svg");
exports.GenericIconAnchorImage = GenericIconAnchorImage;
const GenericIconModifiedRightArrowdImage = require("./images/icons/generic/arrow-right-modified.svg");
exports.GenericIconModifiedRightArrowdImage = GenericIconModifiedRightArrowdImage;
const GenericIconOpenBookImage = require("./images/icons/generic/book-open.svg");
exports.GenericIconOpenBookImage = GenericIconOpenBookImage;
const GenericIconBookmarkImage = require("./images/icons/generic/bookmark.svg");
exports.GenericIconBookmarkImage = GenericIconBookmarkImage;
const GenericIconCalculatorImage = require("./images/icons/generic/calculator.svg");
exports.GenericIconCalculatorImage = GenericIconCalculatorImage;
const GenericIconCalendarImage = require("./images/icons/generic/calendar.svg");
exports.GenericIconCalendarImage = GenericIconCalendarImage;
const GenericIconCheckImage = require("./images/icons/generic/check.svg");
exports.GenericIconCheckImage = GenericIconCheckImage;
const GenericIconChevronsLeftImage = require("./images/icons/generic/chevrons-left.svg");
exports.GenericIconChevronsLeftImage = GenericIconChevronsLeftImage;
const GenericIconChevronsRightImage = require("./images/icons/generic/chevrons-right.svg");
exports.GenericIconChevronsRightImage = GenericIconChevronsRightImage;
const GenericIconClockImage = require("./images/icons/generic/clock.svg");
exports.GenericIconClockImage = GenericIconClockImage;
const GenericIconCompassImage = require("./images/icons/generic/compass.svg");
exports.GenericIconCompassImage = GenericIconCompassImage;
const GenericIconCPUImage = require("./images/icons/generic/cpu.svg");
exports.GenericIconCPUImage = GenericIconCPUImage;
const GenericIconDollarSignImage = require("./images/icons/generic/dollar-sign.svg");
exports.GenericIconDollarSignImage = GenericIconDollarSignImage;
const GenericIconDownChevronImage = require("./images/icons/generic/chevron-down.svg");
exports.GenericIconDownChevronImage = GenericIconDownChevronImage;
const GenericIconLeftChevronImage = require("./images/icons/generic/chevron-left.svg");
exports.GenericIconLeftChevronImage = GenericIconLeftChevronImage;
const GenericIconRightChevronImage = require("./images/icons/generic/chevron-right.svg");
exports.GenericIconRightChevronImage = GenericIconRightChevronImage;
const GenericIconUpChevronImage = require("./images/icons/generic/chevron-up.svg");
exports.GenericIconUpChevronImage = GenericIconUpChevronImage;
const GenericIconFileTextmage = require("./images/icons/generic/file-text.svg");
exports.GenericIconFileTextmage = GenericIconFileTextmage;
const GenericIconEditImage = require("./images/icons/generic/edit.svg");
exports.GenericIconEditImage = GenericIconEditImage;
const GenericIconEdit2Image = require("./images/icons/generic/edit-2.svg");
exports.GenericIconEdit2Image = GenericIconEdit2Image;
const GenericIconEdit3Image = require("./images/icons/generic/edit-3.svg");
exports.GenericIconEdit3Image = GenericIconEdit3Image;
const GenericIconExternalLinkImage = require("./images/icons/generic/external-link.svg");
exports.GenericIconExternalLinkImage = GenericIconExternalLinkImage;
const GenericIconGlobeImage = require("./images/icons/generic/globe.svg");
exports.GenericIconGlobeImage = GenericIconGlobeImage;
const GenericIconHelpCircleImage = require("./images/icons/generic/help-circle.svg");
exports.GenericIconHelpCircleImage = GenericIconHelpCircleImage;
const GenericIconInfoImage = require("./images/icons/generic/info.svg");
exports.GenericIconInfoImage = GenericIconInfoImage;
const GenericIconLayoutImage = require("./images/icons/generic/layout.svg");
exports.GenericIconLayoutImage = GenericIconLayoutImage;
const GenericIconLifeBuoyImage = require("./images/icons/generic/life-buoy.svg");
exports.GenericIconLifeBuoyImage = GenericIconLifeBuoyImage;
const GenericIconLockImage = require("./images/icons/generic/lock.svg");
exports.GenericIconLockImage = GenericIconLockImage;
const GenericIconMailImage = require("./images/icons/generic/mail.svg");
exports.GenericIconMailImage = GenericIconMailImage;
const GenericIconMapPinImage = require("./images/icons/generic/map-pin.svg");
exports.GenericIconMapPinImage = GenericIconMapPinImage;
const GenericIconMegaphoneImage = require("./images/icons/generic/megaphone.svg");
exports.GenericIconMegaphoneImage = GenericIconMegaphoneImage;
const GenericIconMessageCircleImage = require("./images/icons/generic/message-circle.svg");
exports.GenericIconMessageCircleImage = GenericIconMessageCircleImage;
const GenericIconMessageSquareImage = require("./images/icons/generic/message-square.svg");
exports.GenericIconMessageSquareImage = GenericIconMessageSquareImage;
const GenericIconMinimize2Image = require("./images/icons/generic/minimize-2.svg");
exports.GenericIconMinimize2Image = GenericIconMinimize2Image;
const GenericIconPenToolImage = require("./images/icons/generic/pen-tool.svg");
exports.GenericIconPenToolImage = GenericIconPenToolImage;
const GenericIconPhoneImage = require("./images/icons/generic/phone.svg");
exports.GenericIconPhoneImage = GenericIconPhoneImage;
const GenericIconPlayCircleImage = require("./images/icons/generic/play-circle.svg");
exports.GenericIconPlayCircleImage = GenericIconPlayCircleImage;
const GenericIconPlusSignImage = require("./images/icons/generic/plus-sign.svg");
exports.GenericIconPlusSignImage = GenericIconPlusSignImage;
const GenericIconSearchImage = require("./images/icons/generic/search.svg");
exports.GenericIconSearchImage = GenericIconSearchImage;
const GenericIconShareImage = require("./images/icons/generic/share.svg");
exports.GenericIconShareImage = GenericIconShareImage;
const GenericIconShare2Image = require("./images/icons/generic/share-2.svg");
exports.GenericIconShare2Image = GenericIconShare2Image;
const GenericIconSlashImage = require("./images/icons/generic/slash.svg");
exports.GenericIconSlashImage = GenericIconSlashImage;
const GenericIconThumbsUpImage = require("./images/icons/generic/thumbs-up.svg");
exports.GenericIconThumbsUpImage = GenericIconThumbsUpImage;
const GenericIconToolImage = require("./images/icons/generic/tool.svg");
exports.GenericIconToolImage = GenericIconToolImage;
const GenericIconTrendUpImage = require("./images/icons/generic/trend-up.svg");
exports.GenericIconTrendUpImage = GenericIconTrendUpImage;
const GenericIconUserImage = require("./images/icons/generic/user.svg");
exports.GenericIconUserImage = GenericIconUserImage;
const GenericIconUsersImage = require("./images/icons/generic/users.svg");
exports.GenericIconUsersImage = GenericIconUsersImage;
const GenericIconVideoImage = require("./images/icons/generic/video.svg");
exports.GenericIconVideoImage = GenericIconVideoImage;
const GenericIconXCloseImage = require("./images/icons/generic/x-close.svg");
exports.GenericIconXCloseImage = GenericIconXCloseImage;
const GenericIconXOctagonImage = require("./images/icons/generic/x-octagon.svg");

// --Social
exports.GenericIconXOctagonImage = GenericIconXOctagonImage;
const SocialIconFacebookImage = require("./images/icons/social/facebook.svg");
exports.SocialIconFacebookImage = SocialIconFacebookImage;
const SocialIconInstagramImage = require("./images/icons/social/instagram.svg");
exports.SocialIconInstagramImage = SocialIconInstagramImage;
const SocialIconLinkedinImage = require("./images/icons/social/linkedin.svg");
exports.SocialIconLinkedinImage = SocialIconLinkedinImage;
const SocialIconTwitterImage = require("./images/icons/social/twitter.svg");
exports.SocialIconTwitterImage = SocialIconTwitterImage;
const SocialIconZillowImage = require("./images/icons/social/zillow.svg");

// --Quotes
exports.SocialIconZillowImage = SocialIconZillowImage;
const QuoteIconAtlanticDarkImage = require("./images/icons/quotes/atlantic-dark.svg");
exports.QuoteIconAtlanticDarkImage = QuoteIconAtlanticDarkImage;
const QuoteIconAtlanticLightImage = require("./images/icons/quotes/atlantic-light.svg");
exports.QuoteIconAtlanticLightImage = QuoteIconAtlanticLightImage;
const QuoteIconHorizonDarkImage = require("./images/icons/quotes/horizon-dark.svg");
exports.QuoteIconHorizonDarkImage = QuoteIconHorizonDarkImage;
const QuoteIconHorizonLightImage = require("./images/icons/quotes/horizon-light.svg");
exports.QuoteIconHorizonLightImage = QuoteIconHorizonLightImage;
const QuoteIconPacificDarkImage = require("./images/icons/quotes/pacific-dark.svg");
exports.QuoteIconPacificDarkImage = QuoteIconPacificDarkImage;
const QuoteIconPacificLightImage = require("./images/icons/quotes/pacific-light.svg");
exports.QuoteIconPacificLightImage = QuoteIconPacificLightImage;
const QuoteIconPalmDarkImage = require("./images/icons/quotes/palm-dark.svg");
exports.QuoteIconPalmDarkImage = QuoteIconPalmDarkImage;
const QuoteIconPalmLightImage = require("./images/icons/quotes/palm-light.svg");
exports.QuoteIconPalmLightImage = QuoteIconPalmLightImage;
const QuoteIconSunsetDarkImage = require("./images/icons/quotes/sunset-dark.svg");
exports.QuoteIconSunsetDarkImage = QuoteIconSunsetDarkImage;
const QuoteIconSunsetLightImage = require("./images/icons/quotes/sunset-light.svg");
exports.QuoteIconSunsetLightImage = QuoteIconSunsetLightImage;
const QuoteIconThistleDarkImage = require("./images/icons/quotes/thistle-dark.svg");
exports.QuoteIconThistleDarkImage = QuoteIconThistleDarkImage;
const QuoteIconThistleLightImage = require("./images/icons/quotes/thistle-light.svg");

// -Logos

// --ABMG
exports.QuoteIconThistleLightImage = QuoteIconThistleLightImage;
const ABMGLogoFooterIconOnlyWhiteImage = require("./images/logos/abmg/abmg-footer-icon-white.svg");
exports.ABMGLogoFooterIconOnlyWhiteImage = ABMGLogoFooterIconOnlyWhiteImage;
const ABMGLogoFooterArcticBlueImage = require("./images/logos/abmg/abmg-footer-logo-with-icon-arctic-blue.svg");
exports.ABMGLogoFooterArcticBlueImage = ABMGLogoFooterArcticBlueImage;
const ABMGLogoNavIconOnlyDefaultImage = require("./images/logos/abmg/abmg-nav-icon-default.svg");
exports.ABMGLogoNavIconOnlyDefaultImage = ABMGLogoNavIconOnlyDefaultImage;
const ABMGLogoNavDefaultImage = require("./images/logos/abmg/abmg-nav-logo-with-icon-default.svg");

// --Affiliates
exports.ABMGLogoNavDefaultImage = ABMGLogoNavDefaultImage;
const CharlotteCrownWhiteImage = require("./images/logos/affiliates/charlotte-crown-white.svg");
exports.CharlotteCrownWhiteImage = CharlotteCrownWhiteImage;
const NahrepWhiteImage = require("./images/logos/affiliates/nahrep-white.svg");
exports.NahrepWhiteImage = NahrepWhiteImage;
const NammbaWhiteImage = require("./images/logos/affiliates/nammba-white.svg");

// --Awards
exports.NammbaWhiteImage = NammbaWhiteImage;
const LogoFiftyBestCompaniesImage = require("./images/logos/awards/50-best-companies.svg");
exports.LogoFiftyBestCompaniesImage = LogoFiftyBestCompaniesImage;
const LogoNMN2022Image = require("./images/logos/awards/nmn-award-2022.svg");
exports.LogoNMN2022Image = LogoNMN2022Image;
const LogoNMN2023DarkImage = require("./images/logos/awards/nmn-award-2023-dark.svg");
exports.LogoNMN2023DarkImage = LogoNMN2023DarkImage;
const LogoNMN2023DarkWhiteTextImage = require("./images/logos/awards/nmn-award-2023-dark-white-text.svg");
exports.LogoNMN2023DarkWhiteTextImage = LogoNMN2023DarkWhiteTextImage;
const LogoNMN2023WhiteImage = require("./images/logos/awards/nmn-award-2023-white.svg");
exports.LogoNMN2023WhiteImage = LogoNMN2023WhiteImage;
const LogoTopWorkPlaces2022Image = require("./images/logos/awards/top-workplaces-2022.svg");

// --Core Values
exports.LogoTopWorkPlaces2022Image = LogoTopWorkPlaces2022Image;
const LogoGenuineCareImage = require("./images/logos/core-values/genuine-care.svg");
exports.LogoGenuineCareImage = LogoGenuineCareImage;
const LogoValueHaveFunImage = require("./images/logos/core-values/have-fun.svg");
exports.LogoValueHaveFunImage = LogoValueHaveFunImage;
const LogoValueInspireGrowthImage = require("./images/logos/core-values/inspire-growth.svg");
exports.LogoValueInspireGrowthImage = LogoValueInspireGrowthImage;
const LogoEqualOpportunityLenderWhiteImage = require("./images/logos/equal-opportunity-lender-white.svg");

/********************************************************************/

// Utils
exports.LogoEqualOpportunityLenderWhiteImage = LogoEqualOpportunityLenderWhiteImage;
// -CSS
const CSSVariables = require("./utils/_variables.css");
exports.CSSVariables = CSSVariables;
const CSSTypography = require("./utils/_typography.css");
exports.CSSTypography = CSSTypography;